import mapProfileDetails from './user/mapProfileDetails';

export default function mapMeResponse(data) {
  const userProfile = data.item;
  return mapProfileDetails(userProfile);
}
